
import { useNavigate } from "react-router-dom";
import { useSession } from "@supabase/auth-helpers-react";
import { VerseHeader } from "./verse/VerseHeader";
import { VerseContainer } from "./verse/VerseContainer";
import { VerseLoader } from "./verse/VerseLoader";
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { useBraceletCheck } from "@/hooks/useBraceletCheck";
import { useVerseData } from "@/hooks/useVerseData";
import { useVerseBackground } from "@/hooks/useVerseBackground";

export function DailyVerse() {
  const { verse, loading, handleNextVerse } = useVerseData();
  const { braceletId, isRegistered } = useBraceletCheck();
  const backgroundStyle = useVerseBackground();
  const navigate = useNavigate();
  const session = useSession();
  const { branding } = useChurchBranding();

  const handleRegisterProduct = () => {
    if (braceletId) {
      navigate(`/products?id=${braceletId}`);
    }
  };

  if (loading) {
    return <VerseLoader backgroundStyle={backgroundStyle} />;
  }

  return (
    <div className="fixed inset-0 flex flex-col items-center overflow-auto" style={backgroundStyle}>
      <VerseHeader backgroundStyle={backgroundStyle} />
      <VerseContainer
        verse={verse}
        onNextVerse={handleNextVerse}
        showRegisterButton={Boolean(braceletId && !isRegistered && session?.user)}
        onRegisterClick={handleRegisterProduct}
      />
    </div>
  );
}
